import { Box, Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { apiPayloadCreation } from "./DashBoardHelperFunction";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import GraphDashboardActions from "../../../Actions/GraphDashboardActions";
import ChartsDateSelector from "./ChartsDateSelector";
import ChartExport from "./ChartExport";
import commonUtils from "../../../helpers/commonUtils";
export default function ChartAction({
  keyOfChart,
  equipmentKpiRef,
  inspectionKpiRef,
  ticketKpiRef,
  OrgKpiRef,
  rows,
  selectedEquipmentGroupId,
}) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [stateAnchorEl, setStateAnchorEl] = React.useState(null);
  const [showDatePicker, setShowDatePicker] = React.useState(false);
  const [timeFrameEvent, setTimeFrameEvent] = React.useState("Last 30 days");
  const optionList2 = [
    { Name: localization.last30, value: "Last 30 days" },
    { Name: localization.last60, value: "Last 2 month" },
    { Name: localization.customize, value: "datePicker" },
  ];
  const handleStateClick = (event) => {
    setStateAnchorEl(event.currentTarget);
  };
  const handleStateClose = (newState) => {
    if (newState) {
      if (newState === "datePicker") {
        setTimeFrameEvent(localization.customize);
        setShowDatePicker(true);
      } else {
        setTimeFrameEvent(newState);
        if (showDatePicker) {
          setShowDatePicker(false);
        }
        let payLoad;
        if (newState === "Last 30 days") {
          payLoad = apiPayloadCreation(30);
        } else {
          payLoad = apiPayloadCreation(60);
        }

        setGlobalSpinner(true);
        if (keyOfChart === "InspectionKpi") {
          GraphDashboardActions.getInspectionKpiDat(payLoad);
        } else if (keyOfChart === "EquiStatusDistribution") {
          GraphDashboardActions.getDashboardEquipmentStatusDistribution(
            payLoad
          );
        } else if (keyOfChart === "TicketKpi") {
          GraphDashboardActions.getTicketKpiData(payLoad);
          payLoad["AnlagegruppeId"] = selectedEquipmentGroupId;
          GraphDashboardActions.getEqupipmentTicketCountKPIData(payLoad);
        } else if (commonUtils.isUserOrganisationAdmin()) {
          GraphDashboardActions.getOrganisationKpiData(payLoad);
        }
      }
    }
    setStateAnchorEl(null);
  };
  return (
    <Box sx={{ display: "flex", gap: 1 }} id="mainGridButton">
      <Button
        variant="contained"
        className="gridTableButton gridTableButtonStyle"
        style={{ marginLeft: 8 }}
        onClick={handleStateClick}
        endIcon={<UnfoldMoreIcon />}
        // sx={{ textTransform: "none" }}
      >
        {localization.timeFrame +
          ": " +
          (timeFrameEvent == "Last 30 days"
            ? localization.last30
            : timeFrameEvent == "Last 2 month"
            ? localization.last60
            : localization.customize)}
      </Button>
      <Menu
        anchorEl={stateAnchorEl}
        open={Boolean(stateAnchorEl)}
        onClose={() => handleStateClose(null)}
      >
        {optionList2.map((item, index) => (
          <MenuItem
            key={index}
            style={{ fontSize: "16px" }}
            onClick={() => handleStateClose(item.value)}
          >
            {item.Name}
          </MenuItem>
        ))}
      </Menu>
      {showDatePicker && (
        <ChartsDateSelector
          keyOfChart={keyOfChart}
          selectedEquipmentGroupId={selectedEquipmentGroupId}
        />
      )}
      <ChartExport
        keyOfChart={keyOfChart}
        refValue={
          keyOfChart === "EquiStatusDistribution"
            ? equipmentKpiRef
            : keyOfChart === "InspectionKpi"
            ? inspectionKpiRef
            : keyOfChart === "TicketKpi"
            ? ticketKpiRef
            : OrgKpiRef
        }
        rows={rows}
      />
    </Box>
  );
}
